import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import { Checkmark } from '../../icons';
import { BottomSheetContentLayout } from '../BottomSheet';
import { CircularLoader } from '../CircularLoader';
import { useOverlayContext } from '../OverlayContext';
import { Searchbox } from '../Searchbox';
import { Typography } from '../Typography';
import styles from './AutocompleteBottomSheet.module.scss';
export function AutocompleteBottomSheet(props) {
    const { options, getOptionLabel = (option)=>String(option), renderOption, filterOptions, getOptionDisabled, getOptionSelected, onChange, value, multiple, freeSolo, filterSelectedOptions, loading, noOptionsText, label, testId, disableCloseOnSelect, inputValue } = props;
    const { popBottomSheetPage } = useOverlayContext();
    const deriveInitialSearchValue = ()=>{
        if (inputValue != null) return inputValue;
        if (value == null || multiple) return '';
        return getOptionLabel(value);
    };
    const [searchValue, setSearchValue] = useState(deriveInitialSearchValue);
    const [hasUserTyped, setHasUserTyped] = useState(false);
    const [selectedValue, setSelectedValue] = useState(value);
    const isOptionSelected = (option)=>{
        if (selectedValue == null) return false;
        if (multiple && Array.isArray(selectedValue)) {
            return selectedValue.some((v)=>getOptionSelected ? getOptionSelected(option, v) : option === v);
        }
        return getOptionSelected ? getOptionSelected(option, selectedValue) : option === selectedValue;
    };
    const filteredOptions = (()=>{
        let opts = options;
        if (filterSelectedOptions && multiple && Array.isArray(selectedValue)) {
            opts = opts.filter((option)=>!isOptionSelected(option));
        }
        if (!hasUserTyped || !searchValue) {
            return opts;
        }
        if (filterOptions) {
            return filterOptions(opts, {
                inputValue: searchValue,
                getOptionLabel
            });
        }
        const filter = createFilterOptions();
        return filter(opts, {
            inputValue: searchValue,
            getOptionLabel
        });
    })();
    const showDoneButton = !!multiple || !!freeSolo;
    const handleOptionClick = (option)=>{
        if (multiple) {
            const currentArr = Array.isArray(selectedValue) ? selectedValue : [];
            const alreadySelected = currentArr.some((v)=>getOptionSelected ? getOptionSelected(option, v) : option === v);
            const newValue = alreadySelected ? currentArr.filter((v)=>!(getOptionSelected ? getOptionSelected(option, v) : option === v)) : [
                ...currentArr,
                option
            ];
            setSelectedValue(newValue);
            if (onChange) {
                onChange({}, newValue, alreadySelected ? 'remove-option' : 'select-option');
            }
        } else {
            setSelectedValue(option);
            if (onChange) {
                onChange({}, option, 'select-option');
            }
            if (!disableCloseOnSelect) {
                popBottomSheetPage();
            }
        }
    };
    const handleDoneClick = ()=>{
        if (freeSolo && !multiple && searchValue) {
            if (onChange) {
                onChange({}, searchValue, 'create-option');
            }
        }
        popBottomSheetPage();
    };
    const handleInputChange = (newValue)=>{
        setHasUserTyped(true);
        setSearchValue(newValue);
    };
    const hasOptions = filteredOptions.length > 0;
    const showNoOptions = !loading && !hasOptions;
    return /*#__PURE__*/ _jsxs(BottomSheetContentLayout, {
        header: {
            title: label,
            paddingBottom: 0,
            gutter: 'm',
            subtitle: /*#__PURE__*/ _jsx(Searchbox, {
                variant: "textfield",
                fluidWidth: true,
                autoFocus: true,
                testId: testId ? "".concat(testId, "-mobile-searchbox") : undefined,
                value: searchValue,
                onChange: (e)=>handleInputChange(e.target.value),
                onClear: ()=>handleInputChange('')
            })
        },
        footer: showDoneButton ? {
            primaryAction: {
                text: 'Done',
                onClick: handleDoneClick
            },
            paddingTop: 8
        } : undefined,
        children: [
            loading && /*#__PURE__*/ _jsx("div", {
                className: styles.loaderContainer,
                "data-testid": testId ? "".concat(testId, "-mobile-loading") : undefined,
                children: /*#__PURE__*/ _jsx(CircularLoader, {})
            }),
            showNoOptions && noOptionsText && /*#__PURE__*/ _jsx("div", {
                className: styles.noOptions,
                "data-testid": testId ? "".concat(testId, "-mobile-no-options") : undefined,
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: noOptionsText
                })
            }),
            filteredOptions.map((option, index)=>{
                const selected = isOptionSelected(option);
                const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                return /*#__PURE__*/ _jsxs("div", {
                    "data-testid": testId ? "".concat(testId, "-mobile-option-").concat(index) : undefined,
                    className: "".concat(styles.option, " ").concat(disabled ? styles.disabled : ''),
                    onClick: !disabled ? ()=>handleOptionClick(option) : undefined,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.optionContent,
                            children: renderOption ? renderOption(option, {
                                selected,
                                inputValue: searchValue
                            }) : /*#__PURE__*/ _jsx(Typography, {
                                children: getOptionLabel(option)
                            })
                        }),
                        selected && /*#__PURE__*/ _jsx(Checkmark, {
                            testId: testId ? "".concat(testId, "-mobile-option-").concat(index, "-checkmark") : undefined,
                            size: 20
                        })
                    ]
                }, "".concat(index, "-").concat(getOptionLabel(option)));
            })
        ]
    });
}
